var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNodejs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 371.916,
    height: 227.78,
    viewBox: "0 0 371.916 227.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M231.915,226.5l-35.42,20.444a4.275,4.275,0,0,0-2.141,3.7v40.917a4.274,4.274,0,0,0,2.141,3.7l35.423,20.46a4.289,4.289,0,0,0,4.279,0l35.417-20.46a4.285,4.285,0,0,0,2.135-3.7V250.645a4.275,4.275,0,0,0-2.144-3.7L236.193,226.5a4.306,4.306,0,0,0-4.288,0",
    transform: "translate(-194.354 -225.925)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.847,
    y1: -1.034,
    x2: -0.838,
    y2: -1.034,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3e863d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#55934f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5aad45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M195.4,294.183a4.286,4.286,0,0,0,1.261,1.106l30.384,17.55,5.061,2.909a4.293,4.293,0,0,0,2.467.559,4.375,4.375,0,0,0,.841-.154l37.357-68.4a4.237,4.237,0,0,0-1-.79l-23.193-13.393-12.26-7.054a4.473,4.473,0,0,0-1.11-.446Zm0,0",
    transform: "translate(-195.398 -226.069)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.742,
    y1: -0.932,
    x2: -0.737,
    y2: -0.932,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#3e863d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#619857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76ac64"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M234.051,225.95a4.32,4.32,0,0,0-1.711.548l-35.319,20.385,38.085,69.369a4.247,4.247,0,0,0,1.522-.525l35.42-20.46a4.292,4.292,0,0,0,2.068-2.922L235.291,226.02a4.447,4.447,0,0,0-.866-.086c-.118,0-.235.006-.353.017",
    transform: "translate(-197.021 -225.934)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -2.148,
    y1: -2.103,
    x2: -2.138,
    y2: -2.103,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6bbf47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#79b461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#75ac64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#659e5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3e863d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nodejs",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M210.943,253.566a7.07,7.07,0,0,1-3.523-.942l-11.213-6.638c-1.675-.937-.858-1.268-.305-1.459a22.638,22.638,0,0,0,5.07-2.312.851.851,0,0,1,.835.059l8.614,5.112a1.136,1.136,0,0,0,1.041,0L245.049,228a1.059,1.059,0,0,0,.513-.908V188.333a1.078,1.078,0,0,0-.52-.925l-33.574-19.371a1.033,1.033,0,0,0-1.034,0l-33.567,19.371a1.07,1.07,0,0,0-.532.916v38.758a1.035,1.035,0,0,0,.521.9l9.2,5.313c4.994,2.5,8.046-.446,8.046-3.4V191.637a.958.958,0,0,1,.975-.967h4.254a.962.962,0,0,1,.967.967v38.27c0,6.659-3.632,10.484-9.946,10.484-1.942,0-3.472,0-7.743-2.1l-8.811-5.078a7.1,7.1,0,0,1-3.523-6.129V188.325A7.058,7.058,0,0,1,173.8,182.2l33.621-19.4a7.365,7.365,0,0,1,7.062,0l33.579,19.4a7.086,7.086,0,0,1,3.523,6.121v38.758a7.106,7.106,0,0,1-3.523,6.121l-33.579,19.4a7.059,7.059,0,0,1-3.54.942",
    transform: "translate(-27.119 -25.786)",
    fill: "#689f63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M227.619,230.245c-14.7,0-17.777-6.746-17.777-12.4a.966.966,0,0,1,.973-.967h4.338a.971.971,0,0,1,.958.822c.656,4.421,2.606,6.65,11.493,6.65,7.079,0,10.089-1.6,10.089-5.353,0-2.161-.858-3.766-11.854-4.843-9.2-.908-14.881-2.934-14.881-10.291,0-6.776,5.717-10.812,15.293-10.812,10.753,0,16.083,3.733,16.756,11.753a.979.979,0,0,1-.261.748,1,1,0,0,1-.715.311h-4.363a.964.964,0,0,1-.942-.757c-1.051-4.649-3.59-6.137-10.492-6.137-7.726,0-8.626,2.69-8.626,4.708,0,2.447,1.059,3.161,11.484,4.54,10.324,1.37,15.226,3.3,15.226,10.56,0,7.314-6.1,11.51-16.747,11.51m40.91-41.1h1.127a.979.979,0,0,0,1.1-1.026c0-.992-.681-.992-1.059-.992h-1.16ZM267.11,186h2.5c.858,0,2.539,0,2.539,1.917a1.669,1.669,0,0,1-1.37,1.782c1,.067,1.068.723,1.2,1.648a7.087,7.087,0,0,0,.378,1.917h-1.539c-.042-.336-.277-2.186-.277-2.287-.1-.412-.244-.614-.757-.614h-1.27v2.909h-1.4Zm-3,3.615a3.826,3.826,0,1,0-.008-.008m11.9.025a6.469,6.469,0,1,0-.008,0",
    transform: "translate(-33.421 -29.171)",
    fill: "#689f63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M79.816,76.129a4.3,4.3,0,0,0-2.151-3.737L42.055,51.9a4.158,4.158,0,0,0-1.957-.563H39.73a4.231,4.231,0,0,0-1.967.563L2.154,72.392A4.333,4.333,0,0,0,0,76.133l.078,55.186a2.119,2.119,0,0,0,1.068,1.858,2.035,2.035,0,0,0,2.135,0l21.17-12.123A4.342,4.342,0,0,0,26.6,117.32V91.539a4.288,4.288,0,0,1,2.148-3.724l9.013-5.191a4.276,4.276,0,0,1,2.152-.578,4.2,4.2,0,0,1,2.139.578l9.008,5.189a4.29,4.29,0,0,1,2.152,3.724v25.779a4.356,4.356,0,0,0,2.156,3.733l21.156,12.115a2.1,2.1,0,0,0,2.152,0,2.159,2.159,0,0,0,1.066-1.858Zm168.036,28.733a1.069,1.069,0,0,1-.538.93l-12.231,7.05a1.078,1.078,0,0,1-1.074,0l-12.233-7.05a1.065,1.065,0,0,1-.538-.93V90.741a1.082,1.082,0,0,1,.53-.933l12.224-7.062a1.086,1.086,0,0,1,1.085,0l12.233,7.062a1.072,1.072,0,0,1,.538.933ZM251.156.272a2.15,2.15,0,0,0-3.2,1.881V56.8a1.5,1.5,0,0,1-2.257,1.3l-8.92-5.138a4.294,4.294,0,0,0-4.3,0L196.86,73.525a4.292,4.292,0,0,0-2.152,3.716V118.37a4.306,4.306,0,0,0,2.152,3.724l35.622,20.573a4.319,4.319,0,0,0,4.3,0l35.622-20.581a4.311,4.311,0,0,0,2.152-3.724V15.859a4.311,4.311,0,0,0-2.211-3.758Zm118.622,90.1a4.3,4.3,0,0,0,2.138-3.718V76.683a4.3,4.3,0,0,0-2.141-3.72L334.38,52.416a4.3,4.3,0,0,0-4.313,0L294.453,72.972A4.293,4.293,0,0,0,292.3,76.7v41.112a4.316,4.316,0,0,0,2.169,3.741l35.387,20.169a4.29,4.29,0,0,0,4.22.025l21.405-11.9a2.147,2.147,0,0,0,.017-3.741l-35.832-20.564a2.134,2.134,0,0,1-1.085-1.858v-12.9a2.134,2.134,0,0,1,1.076-1.863l11.148-6.432a2.126,2.126,0,0,1,2.144,0l11.157,6.432a2.144,2.144,0,0,1,1.076,1.858v10.139a2.145,2.145,0,0,0,3.228,1.858Zm0,0",
    transform: "translate(0 0)",
    fill: "#333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M393.164,105.179a.816.816,0,0,1,.824,0l6.835,3.943a.825.825,0,0,1,.412.715v7.895a.825.825,0,0,1-.412.715l-6.835,3.943a.816.816,0,0,1-.824,0l-6.831-3.943a.823.823,0,0,1-.42-.715v-7.895a.815.815,0,0,1,.412-.715Zm0,0",
    transform: "translate(-61.463 -16.734)",
    fill: "#689f63",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(97.566 52.049)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M302.761,237.525,202.954,188.6,151.778,293l99.805,48.925Zm0,0",
    transform: "translate(-187.573 -219.981)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(98.443 52.17)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M144.07,250.96l70.475,95.384,93.2-68.861L237.27,182.1Zm0,0",
    transform: "translate(-187.223 -219.066)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(99.808 52.057)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M197.02,225.934v90.32H274.1v-90.32Zm0,0",
    transform: "translate(-197.021 -225.934)",
    fill: "url(#linear-gradient-3)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejs);
export default __webpack_public_path__ + "static/media/nodejs.b2768508a257415b36becf028edc460b.svg";
export { ForwardRef as ReactComponent };